<template>
  <el-container class="main">
    <el-aside width="200px">
      <!-- <img src="../../assets/logo.png"> -->
      <el-image class="image" fit="scale-down" :src="require('../../assets/logo.png')"></el-image>
      <sidebar class="tree"></sidebar>
    </el-aside>
    <el-main>
      <el-container class="main">
        <el-header>
          <navbar></navbar>
        </el-header>
        <el-main class="main-details">
          <router-view/>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
</template>
<script>
import sidebar from "./sidebar/index";
import navbar from "./navbar/index";
export default {
  data() {
    return {};
  },
  components: {
    sidebar,
    navbar
  },
  created() {
    if (!localStorage.getItem("isLogin")) {
      this.$router.push("/login");
    }
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main {
  height: 100%;
  width: 100%;
}

.tree {
  height: calc(100vh - 70px);
  background-color: #323944;
  border-right: solid 1px #e6e6e6;
}
.image {
  width: 100%;
  height: 66px;
  background: #FFFFFF;
}
.el-main {
  padding: 0px;
}
.main-details {
  width: 100%;
  height: 100%;
  padding: 10px;
}
.el-header {
  padding: 0px;
}
</style>
